import { Injectable } from "@angular/core";
import dayjs, { Dayjs } from "dayjs";
import localeData from "dayjs/plugin/localeData";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";

dayjs.extend(localeData);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

@Injectable({
  providedIn: "root",
})
export class LorenDateUtilsService {

  public static getDaysDiff(
    endDate: string | Date | Dayjs,
    startDate: string | Date | Dayjs
  ): number {
    return dayjs.duration(dayjs(endDate).diff(startDate)).asDays();
  }

  public static getMomentFromUnix(timestamp: number) {
    return dayjs.unix(timestamp);
  }

  public static getMomentNow(): Dayjs {
    return dayjs();
  }

  public static getMomentFromDate(date: string | Date | Dayjs): Dayjs {
    return dayjs(date);
  }

  public static getMoment(date: Dayjs | string | Date): Dayjs {
    return dayjs(LorenDateUtilsService.getUtcDate(date));
  }

  public static getMomentUtc(date: Dayjs | string | Date): Dayjs {
    return dayjs.utc(LorenDateUtilsService.getUtcDate(date));
  }

  public static getMomentTz(date: Dayjs | string | Date): Dayjs {
    return LorenDateUtilsService.getMoment(date).tz();
  }

  public static getSubtractedFromNowDate(numberOfDays: number) {
    return dayjs().subtract(numberOfDays, "days");
  }

  private static getUtcDate(date: Dayjs | string | Date) {
    // TODO: redundant once timestamp format is fixed on the server: ISO 8601
    const momentParsed = dayjs(date);

    return Date.UTC(
      momentParsed.year(),
      momentParsed.month(),
      momentParsed.date(),
      momentParsed.hour(),
      momentParsed.minute(),
      momentParsed.second(),
      momentParsed.millisecond()
    );
  }
}
